import { motion } from "framer-motion";
import { Star } from "lucide-react";

const STATS = [
  { value: "0%", label: "de comissão por pedido" },
  { value: "minutos", label: "pra publicar o cardápio" },
  { value: "0%", label: "de fidelidade" },
  { value: "24h", label: "com Garçom IA ativo" },
];

const TESTIMONIALS = [
  {
    quote: "Antes eu perdia tempo respondendo WhatsApp com foto do cardápio. Agora mando o link e o pedido já chega organizado. Simples assim.",
    name: "Marcos Gomes",
    role: "Dono de hamburgueria · SP",
    photo: "/avatars/marcos.svg",
    metric: "Pedidos mais organizados",
  },
  {
    quote: "Coloquei o QR Code nas mesas no primeiro dia. Os clientes adoraram, pedem sem precisar chamar garçom e eu consigo atender mais mesas.",
    name: "Carla Lima",
    role: "Proprietária de pizzaria · MG",
    photo: "/avatars/carla.svg",
    metric: "Mais mesas atendidas",
  },
  {
    quote: "Importei meu cardápio de PDF em minutos. As fotos que a IA gerou ficaram melhores que as que eu tirei com celular.",
    name: "Rafael Pinto",
    role: "Chef e dono · RJ",
    photo: "/avatars/rafael.svg",
    metric: "Cardápio no ar em minutos",
  },
  {
    quote: "Sexta às 20h, pico total: minha equipe focada no salão e o Atendimento Inteligente respondendo os pedidos do delivery no WhatsApp, na hora. Ninguém fica esperando.",
    name: "Ana Souza",
    role: "Gerente de café · PR",
    photo: "/avatars/ana.svg",
    metric: "Nunca perde um pedido no pico",
  },
];

export function Testimonials() {
  return (
    <section className="py-16 md:py-24">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mx-auto max-w-2xl text-center"
        >
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl" style={{ color: "#fff" }}>
            O que dizem os restaurantes
          </h2>
          <p className="mt-4 text-lg" style={{ color: "rgba(255,255,255,0.8)" }}>
            O que donos de restaurante dizem depois de usar o MenuzAI.
          </p>
        </motion.div>

        {/* Aggregate stats */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-10 flex flex-wrap justify-center gap-8 md:gap-14"
        >
          {STATS.map((s) => (
            <div key={s.label} className="text-center">
              <p className="text-3xl font-bold" style={{ color: "#fff" }}>{s.value}</p>
              <p className="mt-0.5 text-sm" style={{ color: "rgba(255,255,255,0.75)" }}>{s.label}</p>
            </div>
          ))}
        </motion.div>

        {/* Testimonial cards */}
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex flex-col rounded-2xl bg-white p-6 shadow-lg"
            >
              {/* Stars */}
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="h-4 w-4 fill-amber-400 text-amber-400" />
                ))}
              </div>

              {/* Quote */}
              <p className="mt-4 flex-1 text-sm leading-relaxed text-zinc-600">
                "{t.quote}"
              </p>

              {/* Metric badge */}
              <div className="mt-5">
                <span className="inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold" style={{ backgroundColor: "rgba(255,106,0,0.1)", color: "#FF6A00" }}>
                  {t.metric}
                </span>
              </div>

              {/* Author */}
              <div className="mt-4 flex items-center gap-3 border-t pt-4">
                <img
                  src={t.photo}
                  alt={t.name}
                  className="h-10 w-10 rounded-full object-cover ring-2 ring-white shadow-sm"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = "none";
                    const fallback = el.nextElementSibling as HTMLElement;
                    if (fallback) fallback.style.display = "flex";
                  }}
                />
                <span
                  className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#FF6A00] to-[#FF8C00] text-sm font-bold text-white"
                >
                  {t.name.split(" ").map(w => w[0]).join("")}
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-semibold leading-tight text-zinc-900">{t.name}</p>
                  <p className="truncate text-xs text-zinc-500">{t.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-12 text-center"
        >
          <p className="text-sm" style={{ color: "rgba(255,255,255,0.65)" }}>
            Junte-se aos primeiros restaurantes que já simplificaram seus pedidos com o MenuzAI.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
